import React, { useContext, useEffect, useState } from "react";
import Modal from "react-modal";
import AuthContext from "../../shared/context/authContext/AuthContext";
import { getStripeClinicianProducts } from "../../shared/services/stripe/stripe.service";
import Checkout from "../subscription/Checkout";
import { IGetProductResponse } from "../../shared/services/stripe/interfaces/get-products.interfacae";
import { IStripeProduct } from "../../shared/services/stripe/interfaces/product.interface";
import { IStripePrice } from "../../shared/services/stripe/interfaces/price.interface";
import { BusinessHubspotRole } from "../../shared/enums/business-role.enum";
import { formatPriceInteger } from "../../shared/utils/format-price";
import pricingImg from "../../../assets/images/pricingbanner.png";

const FreeTrialEnded = () => {
    const [isMobile] = useState(window.outerWidth < 768);

    const [products, setProducts] = useState<IGetProductResponse[]>([]);

    const [selectedProduct, setSelectedProduct] = useState<{
        product: IStripeProduct;
        price: IStripePrice;
    }>();

    const { state } = useContext(AuthContext);

    const [showCheckoutModal, setShowCheckoutModal] = useState(false);

    useEffect(() => {
        if (!state?.user?.persona) return;

        if (state?.user?.persona !== BusinessHubspotRole.B2C_CLINICIAN) {
            window.location.href = "/app/lets-play";
            return;
        }

        getStripeClinicianProducts().then((response) => {
            setProducts(response.response);
        });
    }, [state?.user?.persona]);

    return (
        <>
            <div className="bg-aha-green">
                <div className="bg-aha-green-dark -mt-3">
                    <div className="px-6 pt-7 pb-6 max-w-5xl text-center mb-8 text-white mx-auto">
                        <h1 className="text-3xl mb-2 font-century-gothic-bold">
                            Your 21-Day Free Trial Has Ended
                        </h1>
                        <p className="leading-6 mb-7">
                            We hope you've enjoyed using At Home Articulation to
                            connect with families and send homework quickly.
                            Keep the momentum going — subscribe now for improved
                            carryover and better treatment outcomes!
                        </p>
                        <img
                            src={pricingImg}
                            alt="Pricing Banner"
                            className="w-5/6 max-w-lg mx-auto mt-4"
                        />
                    </div>
                </div>
                <div className="px-6 pb-20 max-w-5xl mx-auto">
                    <div className="md:flex space-y-6 md:space-y-0 gap-8">
                        {products?.map?.((product) => {
                            return (
                                <div
                                    key={product.product.id}
                                    className="text-center md:w-3/5 mx-auto"
                                >
                                    <div className="bg-white p-4 text-aha-black">
                                        <div className="mb-4">
                                            <span className="text-aha-orange text-3xl font-century-gothic-bold">
                                                {product.product.subscriptionType.toLowerCase() ===
                                                "quarterly"
                                                    ? "QUARTERLY"
                                                    : "YEARLY"}
                                            </span>
                                        </div>
                                        <div className="text-4xl mb-4">
                                            {formatPriceInteger(
                                                product.prices[0].unit_amount
                                            )}
                                        </div>
                                        <div>
                                            <span>
                                                Includes free, unlimited student
                                                licenses <br /> (yes, you read
                                                that right!)
                                            </span>
                                        </div>
                                    </div>

                                    <div className="px-4">
                                        <button
                                            className="w-full mt-3 block bg-aha-black py-3 text-white"
                                            onClick={() => {
                                                setSelectedProduct({
                                                    product: product.product,
                                                    price: product.prices[0],
                                                });
                                                setShowCheckoutModal(true);
                                            }}
                                        >
                                            Subscribe now
                                        </button>
                                    </div>
                                </div>
                            );
                        })}
                    </div>
                </div>
            </div>

            <Modal
                ariaHideApp={false}
                isOpen={showCheckoutModal}
                onClose={() => setShowCheckoutModal(false)}
                style={{
                    content: {
                        top: "30%",
                        left: "50%",
                        right: "auto",
                        bottom: "auto",
                        marginRight: "-50%",
                        transform: "translate(-50%, -30%)",
                        width: isMobile ? "100%" : 600,
                        padding: 0,
                        border: 0,
                    },
                }}
            >
                {selectedProduct && (
                    <Checkout
                        selectedProduct={selectedProduct}
                        onDismiss={(purchased: boolean) => {
                            setShowCheckoutModal(false);
                        }}
                    />
                )}
            </Modal>
        </>
    );
};

export default FreeTrialEnded;
